<div *ngIf="storeCoverageData">
    <div class="middleContent">
        <section>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row mb-2 g-2">
                            <label class="col-sm-4 col-form-label required">TITLE</label>
                            <div class="col-sm-8">
                                <input id="title" type="text" class="form-control"
                                    [(ngModel)]="storeCoverageData!.title"
                                    (ngModelChange)="onAnyFieldValueChange($event)" maxlength="200" appUnsavedChanges>
                            </div>
                        </div>

                        <div class="row mb-2 g-2">
                            <label class="col-sm-4 col-form-label required">CATEGORY</label>
                            <div class="col-sm-4">
                                <select class="form-select border-0" aria-label="Default select example"
                                    [(ngModel)]="storeCoverageData!.category">
                                    <option value="0">Select Category</option>
                                    <option *ngFor="let item of categoryList" [value]="item.value">
                                        {{item.label}}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="row mb-2 g-2">
                            <label class="col-sm-4 col-form-label required">DATE</label>
                            <div class="col-sm-4">
                                <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}"
                                    id="storeCoverageDate" [(ngModel)]="storeCoverageData!.storeCoverageDate">
                                </p-calendar>
                            </div>

                        </div>

                        <div class="row mb-2 g-2">
                            <label class="col-sm-4 col-form-label required">UPLOAD ATTACHMENT</label>
                            <div class="col-sm-8">
                                <div class="input-group custom-file-button">
                                    <input type="file" id="storeCoverageFileInput" #fileInput accept=".xls,.xlsx"
                                        class="form-control" (change)="onFilesSelected($event)"><label
                                        for="storeCoverageFileInput" class="input-group-text">UPLOAD</label>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3 mt-3">
                            <div class="col-md-4">
                            </div>
                            <div class="col-md-8 ps-0">
                                <div class="row mb-3">
                                    <div class="col-md-1">
                                        <img src="assets/images/close_mark.svg" alt="Delete" (click)="onDelete()"
                                            *ngIf="storeCoverageData?.fileName"
                                            style="cursor: pointer; width:16px; height:16px;">
                                    </div>

                                    <div class="col-md-10">
                                        <span class="fw-bold" style="text-decoration: none;">{{
                                            storeCoverageData?.fileName }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row nb-2 g-2 mt-1">
                    <div class="col-md-12 text-end">
                        <button class="btn progressBtn float-end" role="button" (click)="saveStoreCoverage()">
                            <img src="assets/images/plus_icon.svg" class="datePickerIcon" alt="">
                            {{ selectedAction === 'ADD' ? 'SAVE' : 'UPDATE' }}
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>